import type {
  CoreApiRequestPayload,
  CoreUser,
  CoreUserPayload,
} from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

/**
 * Update user logged details.
 *
 * @endpoint PUT /api/me
 * @scope shared
 * @see https://flecto.dev/api-4724193
 */
export async function updateUser(user: CoreUserPayload): Promise<CoreUser> {
  const body: CoreApiRequestPayload<CoreUserPayload> = {
    data: {
      type: 'user',
      attributes: user,
    },
  }

  const response = await api.put('/api/me', body)
  const { data } = deserialize<CoreUser>(response.data)

  return data
}
